import { isNotEmpty, type QuestionData } from '@terros/common'
import { getQuestionReportChoiceIndexes } from './reportKpis'

export type QuestionReportChoice = {
  value: number
  label: string
}

export const getQuestionReportChoices = (question: QuestionData): QuestionReportChoice[] | undefined => {
  if (question.choiceType === 'YesNo') return

  return getQuestionReportChoiceIndexes(question).map((value, index) => ({
    value,
    label:
      question.choiceType === 'RatingScale'
        ? getRatingScaleLabel(question.choices, value)
        : (question.choices?.[index] ?? String(value)),
  }))
}

const getRatingScaleLabel = (choices: string[] | undefined, value: number): string => {
  if (value === 1 && isNotEmpty(choices?.at(0))) return `${value} - ${choices[0]}`
  if (value === 5 && isNotEmpty(choices?.at(1))) return `${value} - ${choices[1]}`
  return String(value)
}
